<template>
  <div class="radial-progress">
    <svg class="progress-ring" :height="size" :width="size">
      <filter id="blurMe">
        <feGaussianBlur in="SourceGraphic" stdDeviation="2" />
      </filter>

      <circle
        :style="{ strokeDashoffset: 0, strokeDasharray: `${circumference} ${circumference}` }"
        class="progress-ring__circle bg"
        :stroke-width="stroke"
        fill="transparent"
        :r="radius"
        :cx="position"
        :cy="position"
      />
      <circle
        :style="{ strokeDashoffset: progress, strokeDasharray: `${circumference} ${circumference}` }"
        class="progress-ring__circle shadow"
        :stroke-width="stroke"
        fill="transparent"
        :r="radius"
        :cx="position"
        :cy="position"
        filter="url(#blurMe)"
      />
      <circle
        :style="{ strokeDashoffset: progress, strokeDasharray: `${circumference} ${circumference}` }"
        class="progress-ring__circle"
        :stroke-width="stroke"
        fill="transparent"
        :r="radius"
        :cx="position"
        :cy="position"
      />

      <text
        x="50%"
        y="50%"
        text-anchor="middle"
        stroke="#460281"
        stroke-width="2px"
        dy=".3em"
      >{{ current }} / {{ max }}</text>
    </svg>
  </div>
</template>
<script>
export default {
  name: "RadialProgress",
  props: {
    size: {
      type: Number,
      default: 120
    },
    stroke: {
      type: Number,
      default: 7
    },
    max: {
      type: Number,
      default: 100
    },
    current: {
      type: Number,
      default: 0
    }
  },
  computed: {
    radius: function() {
      return this.size / 2 - this.stroke * 2;
    },
    position: function() {
      return this.size / 2;
    },
    circumference: function() {
      return this.radius * 2 * Math.PI;
    },
    progress: function() {
      return (
        this.circumference - (this.current / this.max) * this.circumference
      );
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.progress-ring__circle {
  transition: stroke-dashoffset 0.75s;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
  stroke-linecap: round;
  stroke: $color-primary;
  &.bg {
    stroke: $color-primary--light;
  }

  &.shadow {
    stroke: #2c255e;
  }
}
</style>